import { Flex, NativeSelect, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAudioSettingsStyles } from './componentStyles/AudioSettings.style'

interface AudioSettingsProps {
  inputs: MediaDeviceInfo[]
  selectedInput: string
  onInputDeviceChange: (deviceId: string) => void
  outputs: MediaDeviceInfo[]
  selectedOutput: string
  onOutputDeviceChange: (deviceId: string) => void
}
export const AudioSettings = ({
  inputs,
  selectedInput,
  onInputDeviceChange,
  outputs,
  selectedOutput,
  onOutputDeviceChange,
}: AudioSettingsProps) => {
  const { t } = useTranslation()
  const handleOutputSelectChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    onOutputDeviceChange(e.target.value)
  }
  const handleInputSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onInputDeviceChange(e.target.value)
  }

  const style = useAudioSettingsStyles()

  // Extract layout properties to apply as native props (Chakra v3 requirement)
  const containerProps = {
    flexDirection: style.container?.flexDirection || ('column' as const),
  }

  const dropdownContainerProps = {
    flexDirection: style.dropdownContainer?.flexDirection,
    gap: style.dropdownContainer?.gap,
  }

  return (
    <Flex css={style.container} {...containerProps}>
      {outputs.length > 0 && (
        <Flex css={style.dropdownContainer} {...dropdownContainerProps}>
          <Text css={style.text}>
            {t('callControl.audioSettings.outputSource')}
          </Text>
          <NativeSelect.Root variant="outline" css={style.select}>
            <NativeSelect.Field
              onChange={handleOutputSelectChange}
              value={selectedOutput}
            >
              {outputs.map((outputDevice) => {
                return (
                  <option
                    key={outputDevice.deviceId}
                    value={outputDevice.deviceId}
                  >
                    {outputDevice.label}
                  </option>
                )
              })}
            </NativeSelect.Field>
          </NativeSelect.Root>
        </Flex>
      )}
      {inputs.length > 0 && (
        <Flex css={style.dropdownContainer} {...dropdownContainerProps}>
          <Text css={style.text}>
            {t('callControl.audioSettings.inputSource')}
          </Text>
          <NativeSelect.Root variant="outline" css={style.select}>
            <NativeSelect.Field
              onChange={handleInputSelectChange}
              value={selectedInput}
            >
              {inputs.map((inputDevice) => {
                return (
                  <option
                    key={inputDevice.deviceId}
                    value={inputDevice.deviceId}
                  >
                    {inputDevice.label}
                  </option>
                )
              })}
            </NativeSelect.Field>
          </NativeSelect.Root>
        </Flex>
      )}
    </Flex>
  )
}
